document.addEventListener("DOMContentLoaded", function () {
  const articleContent = document.getElementById("article-content");
  if (!articleContent) return;

  const headings = articleContent.querySelectorAll('h1, h2');
  if (headings.length === 0) return;

  // Create TOC wrapper
  const tocWrapper = document.createElement('details');
  tocWrapper.className = 'article-toc';
  if (window.innerWidth >= 768) tocWrapper.open = true;

  const tocSummary = document.createElement('summary');
  tocSummary.innerHTML = `
    <h3>Table of Contents</h3>
    <svg class="toc-chevron" aria-hidden="true" focusable="false" role="presentation" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 6.75L12.5 1.25" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
      <path d="M7 6.75L1.5 1.25" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
    </svg>`;
  tocWrapper.appendChild(tocSummary);

  // Build TOC list
  const tocList = document.createElement('ul');
  let lastH1ListItem = null;

  headings.forEach((heading, index) => {
    const text = heading.innerText.trim();
    const id = text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + `-${index}`;
    heading.id = id;

    const listItem = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.innerText = text;
    listItem.appendChild(link);

    if (heading.tagName === 'H1') {
      tocList.appendChild(listItem);
      lastH1ListItem = listItem;
    } else if (heading.tagName === 'H2' && lastH1ListItem) {
      let sublist = lastH1ListItem.querySelector('ul');
      if (!sublist) {
        sublist = document.createElement('ul');
        lastH1ListItem.appendChild(sublist);
      }
      sublist.appendChild(listItem);
    } else {
      tocList.appendChild(listItem);
    }
  });

  tocWrapper.appendChild(tocList);

  // Insert TOC before the **first heading in document order**
  const firstHeading = articleContent.querySelector('h1, h2');
  if (firstHeading) {
    articleContent.insertBefore(tocWrapper, firstHeading);
  } else {
    // Fallback to prepend if no headings found (shouldn't happen)
    articleContent.prepend(tocWrapper);
  }
});